import { _ as _object_without_properties_loose, a as _extends } from './cc-CWi2JB6O.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { cn } from '@repo/lib';
import 'react';

function Price(_param) {
    var { amount, amountClassName, className, currencyCode, currencyCodeClassName, lang } = _param, rest = _object_without_properties_loose(_param, [
        "amount",
        "amountClassName",
        "className",
        "currencyCode",
        "currencyCodeClassName",
        "lang"
    ]);
    if (!amount || !currencyCode) {
        console.warn("No amount and/or currencyCode provided to Price");
        return null;
    }
    return /*#__PURE__*/ jsxs("span", _extends({}, rest, {
        className: cn(className),
        children: [
            /*#__PURE__*/ jsx("span", {
                className: cn("amount", amountClassName),
                children: `${new Intl.NumberFormat(lang, {
                    style: "currency",
                    currency: currencyCode,
                    currencyDisplay: "narrowSymbol"
                }).format(Number.parseFloat(amount))}`
            }),
            /*#__PURE__*/ jsx("span", {
                className: cn("currencyCode ms-1", currencyCodeClassName),
                children: `${currencyCode}`
            })
        ]
    }));
}

export { Price };
